import { render, staticRenderFns } from "./ManufacturerDetails.vue?vue&type=template&id=faaeb6e2&"
import script from "./ManufacturerDetails.vue?vue&type=script&lang=js&"
export * from "./ManufacturerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports